<template>
  <div id="app" class="app-shell" :class="{ 'app-shell--public': !hasWorkspace }">
    <SidebarLeft v-if="hasWorkspace" :open="mobileNavigationOpen" @close="mobileNavigationOpen = false" />
    <div v-if="hasWorkspace" class="app-shell__workspace">
      <AppTopbar @toggle-navigation="mobileNavigationOpen = !mobileNavigationOpen" />
      <main class="app-shell__content" role="main">
        <router-view v-slot="{ Component, route: currentRoute }">
          <keep-alive :include="cachedComponents" :max="6"><component :is="Component" :key="currentRoute.fullPath" /></keep-alive>
        </router-view>
      </main>
    </div>
    <main v-else class="app-shell__public" role="main"><router-view /></main>
    <DetailHost v-if="hasWorkspace" />
    <button v-if="hasWorkspace && mobileNavigationOpen" class="app-shell__backdrop" type="button" aria-label="Fermer la navigation" @click="mobileNavigationOpen = false" />
  </div>
</template>

<script>
import { computed, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import AppTopbar from './components/common/AppTopbar.vue'
import SidebarLeft from './components/SidebarLeft.vue'
import DetailHost from './components/common/DetailHost.vue'

export default {
  name: 'App',
  components: { AppTopbar, DetailHost, SidebarLeft },
  setup() {
    const route = useRoute()
    const mobileNavigationOpen = ref(false)
    const cachedComponents = ['DashboardMain', 'ParseOffer', 'MyOffersList']
    const hasWorkspace = computed(() => route.meta?.showSidebar !== false)
    watch(() => route.fullPath, () => {
      document.title = route.meta?.title || 'Collection — Prexens'
      mobileNavigationOpen.value = false
    }, { immediate: true })
    return { cachedComponents, hasWorkspace, mobileNavigationOpen }
  }
}
</script>
